export default __webpack_public_path__ + "static/media/img_post2_4.5e4d6651.png";